<ng-container *ngIf="!showMarquee">
    <ms-crm-promotion-banner
        *ngFor="let promotion of promotions; trackBy: trackPromoBy; let position = index"
        [promotion]="promotion"
        [listIndex]="position"
        [trackingSource]="trackingSource"></ms-crm-promotion-banner>
</ng-container>
<ng-container *ngIf="showMarquee">
    <ng-container *msComponentProxy="marqueeComponent"></ng-container>
</ng-container>
